export default __webpack_public_path__ + "static/media/n1.f0a84a03.jpg";